import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Event} from "../../../../models/event";
import {EventType} from "../../../../models/event-type";
import {PreviewTranslationsControllerService} from "../../../../services/preview-translations-controller/preview-translations-controller.service";

@Component({
  selector: "translations-edit",
  templateUrl: "./translations-edit.component.html",
  providers: [PreviewTranslationsControllerService],

})
export class TranslationsEditComponent {

  @Input() public previewTranslation;
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public modalClosedWithoutReloadEvent = new EventEmitter();

  constructor(private previewTranslationController: PreviewTranslationsControllerService) {
  }

  public closeModal(event: Event) {
    this.modalClosedEvent.emit(new Event(null, EventType.Update));
  }

  public saveTranslation(event) {
    this.previewTranslationController.setPreviewTranslation(this.previewTranslation).subscribe(
      () => {
        this.closeModal(event);
      },
    );
  }
}
